import { PapiGallection } from '@wix/da-papi-types';
import { InitAdapter } from '../../types';
import { GallerySelectItem } from '../../common/GalleryMultiselect';
import { selectPremiumGalleries } from '../../utils/galleries';

export const initAdapter: InitAdapter = (
  { galleries: allGalleries = [], inGalleries = [], deviation },
  { isEdit, isDraft },
  defaultValues
): GallerySelectItem[] | undefined => {
  const defaultFolderId = defaultValues?.folderId;
  const isSelected = (gallery: PapiGallection) => {
    if (inGalleries.length > 0) {
      // some galleries were already set, use those
      return inGalleries.some(g => g.folderId === gallery.folderId);
    } else if (!(isEdit || isDraft || deviation?.isDreamsofart)) {
      // on a new form, select the default folder only
      if (defaultFolderId) {
        return defaultFolderId === gallery.folderId;
      }
    }
    return false;
  };
  return selectPremiumGalleries(allGalleries).map(gallery => ({
    gallery,
    value: `${gallery.folderId}`,
    selected: isSelected(gallery),
  }));
};
